module.exports = __webpack_public_path__ + "yeni fransa banyo dolabı.jpg?69abe7b63b9f94dd76a61fd2b0ade24c";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/yeni fransa banyo dolabı.jpg
// module id = 383
// module chunks = 0